import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MENU_WIDTH = 240;
var MENU_SMALL_WIDTH = 56;
export var mainContainer = {
  width: '100vw',
  height: '100vh',
  display: 'flex',
  flexDirection: 'row',
  overflow: 'hidden'
};
export var sideNavContainer = function sideNavContainer(isOpen, isMobile) {
  return function (theme) {
    return _objectSpread({
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.white,
      borderRight: "1px solid ".concat(theme.gray150),
      flexShrink: 0,
      transition: 'width .25s cubic-bezier(0.4, 0, 0.2, 1), transform .3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow .3s ease'
    }, isMobile ? {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      zIndex: 1300,
      width: 'min(280px, 85vw)',
      transform: isOpen ? 'translateX(0)' : 'translateX(-105%)',
      boxShadow: isOpen ? '4px 0 24px rgba(0, 0, 0, 0.18)' : 'none',
      overflowY: 'auto',
      overflowX: 'hidden'
    } : {
      position: 'relative',
      width: isOpen ? MENU_WIDTH : MENU_SMALL_WIDTH
    });
  };
};
export var mobileBackdrop = {
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.45)',
  zIndex: 1299,
  backdropFilter: 'blur(3px)',
  WebkitBackdropFilter: 'blur(3px)',
  transition: 'opacity 0.3s ease'
};
export var sideNavHeader = function sideNavHeader(isOpen) {
  return function (theme) {
    return {
      padding: '1.6rem 1.2rem',
      overflowX: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minHeight: '6rem',
      overflow: 'hidden',
      borderBottom: "1px solid ".concat(theme.gray100),
      flexShrink: 0,
      '&:hover': !isOpen && {
        '& > .logo-container': {
          display: 'none'
        },
        '& > .collapse-container': {
          display: 'flex'
        }
      },
      '& .logo-container': {
        overflowX: 'hidden',
        width: '100%'
      },
      '& h4': _objectSpread({
        color: theme.gray800,
        fontWeight: 700,
        fontSize: '1.6rem',
        letterSpacing: '-0.02em'
      }, !isOpen && {
        display: 'none'
      }),
      '& .collapse-container': {
        color: theme.gray400,
        backgroundColor: theme.gray50,
        width: '2.8rem',
        height: '2.8rem',
        cursor: 'pointer',
        borderRadius: 0,
        display: isOpen ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        '&:hover': {
          display: 'flex',
          backgroundColor: theme.gray100,
          '& .icon path': {
            fill: theme.gray700
          }
        },
        '& .icon': {
          width: '1.4rem',
          transform: "rotate(".concat(isOpen ? 0 : -180, "deg)"),
          transition: 'transform .25s cubic-bezier(0.4, 0, 0.2, 1)',
          '& path': {
            fill: theme.gray400
          }
        }
      }
    };
  };
};
export var logoHolder = function logoHolder(bgimage) {
  return function (theme) {
    return _objectSpread({
      width: '100%',
      height: '3rem',
      backgroundImage: "url(".concat(bgimage, ")"),
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }, theme.mode === 'dark' && {
      filter: 'invert(87%) sepia(10%) saturate(500%) hue-rotate(190deg) brightness(95%) contrast(90%)'
    });
  };
};
export var menuListContainer = function menuListContainer(theme) {
  return [{
    overflow: 'hidden auto',
    height: '100%',
    padding: '0.8em 0',
    position: 'relative',
    transition: 'width .25s cubic-bezier(0.4, 0, 0.2, 1)',
    zIndex: 1000,
    '&::-webkit-scrollbar': {
      width: 4
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.gray200,
      borderRadius: 0
    }
  }];
};
export var subMenuList = function subMenuList(theme) {
  return {
    backgroundColor: theme.white,
    color: theme.gray600,
    borderRadius: 0,
    minWidth: 120,
    border: "1px solid ".concat(theme.gray100),
    boxShadow: theme.boxShadowMd
  };
};
export var subMenusTreeContainer = {
  padding: '0.2rem 1rem 0.4rem 3.2rem',
  overflow: 'hidden'
};
export var subSubMenusTreeContainer = {
  padding: '0 0 0.4rem 1rem'
};
export var contentContainer = function contentContainer(theme) {
  return {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto hidden',
    backgroundColor: theme.gray50,
    minWidth: 0
  };
};
export var sideNavContent = {
  flex: 1,
  overflow: 'auto'
};
export var tooltipContainer = {
  display: 'block'
};
export var tooltipContent = {
  '& .tooltip-content': {
    padding: '0 0 0 0.2em',
    backgroundColor: 'transparent',
    boxShadow: 'none'
  }
};
export var menuItem = function menuItem(theme) {
  return {
    color: theme.gray500,
    backgroundColor: 'transparent',
    padding: '0.8em 1em',
    margin: '0.1rem 0.6rem',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexFlow: 'row nowrap',
    cursor: 'pointer',
    borderRadius: 0,
    marginBottom: '0.15rem',
    lineHeight: 1,
    whiteSpace: 'nowrap',
    fontSize: '1.32rem',
    fontWeight: 400,
    transition: 'all 0.15s ease',
    '&:hover': {
      color: theme.gray800,
      backgroundColor: theme.gray50
    },
    '&:focus': {
      outline: 'none'
    },
    '& i': {
      marginRight: '0.7em',
      color: 'inherit',
      fontSize: '1.5rem',
      width: '1.8rem',
      textAlign: 'center'
    },
    '&.active': {
      color: theme.primary,
      backgroundColor: theme.primaryLight,
      fontWeight: 500,
      '&::before': {
        content: "''",
        backgroundColor: theme.primary,
        width: '0.25rem',
        height: 'calc(100% - 0.8rem)',
        position: 'absolute',
        left: '-0.6rem',
        borderRadius: 0
      },
      '& i': {
        color: theme.primary
      }
    }
  };
};
export var menuItemContent = {
  display: 'flex',
  alignItems: 'center'
};
export var menuSubItem = function menuSubItem(theme) {
  return {
    color: theme.gray500,
    backgroundColor: 'transparent',
    padding: '0.8em 0.8em',
    cursor: 'pointer',
    borderRadius: 0,
    display: 'block',
    whiteSpace: 'nowrap',
    fontSize: '1.3rem',
    transition: 'all 0.15s ease',
    '&:hover': {
      color: theme.gray800,
      backgroundColor: theme.gray50
    },
    '&.active': {
      color: theme.primary,
      fontWeight: 500
    }
  };
};
export var menuSubSubItem = function menuSubSubItem(theme) {
  return {
    color: theme.gray500,
    backgroundColor: 'transparent',
    padding: '0.55em 0.8em',
    cursor: 'pointer',
    borderRadius: 0,
    display: 'block',
    whiteSpace: 'nowrap',
    fontSize: '1.2rem',
    transition: 'all 0.15s ease',
    '&:hover': {
      color: theme.gray800,
      backgroundColor: theme.gray50
    },
    '&.active': {
      color: theme.primary,
      fontWeight: 500
    }
  };
};
export var menuSubGroupHeader = function menuSubGroupHeader(theme) {
  return {
    color: theme.gray400,
    fontSize: '1.05rem',
    fontWeight: 600,
    padding: '0.5em 0.8em 0.2em',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    borderTop: "1px solid ".concat(theme.gray100),
    '&:first-of-type': {
      borderTop: 'none'
    }
  };
};
export var menuItemText = {
  display: 'block'
};
export var menuItemRightIcon = function menuItemRightIcon(theme) {
  return {
    color: theme.gray400,
    fontSize: 11
  };
};